module.exports = __webpack_public_path__ + "img/logo.9c1ca1e4.png";